
import intersectionObserver from "@/mixins/intersectionObserver"
import media from "@/mixins/media"

export default {
    name: "JobGalleryV3",
    components: {
        OPicture: () => import("@/components/base/image/OPicture"),
        ResponsiveVimeo: () =>
            import("@/components/base/video/ResponsiveVimeo"),
    },
    mixins: [intersectionObserver, media],
    props: {
        /** Array of images/videos */
        mediaList: {
            type: Array,
            default: null,
        },
        /** Num of columns in grid */
        columns: {
            type: Number,
            default: 2,
        },
    },
    emits: ["show-more"],
    computed: {
        mediaMatrix() {
            const columns = this.mediaList.length < 2 ? 1 : this.columns
            let matrix = []
            let columnSize = Math.ceil(this.mediaList.length / columns)
            for (let i = 0; i < this.mediaList.length; i += columnSize) {
                matrix.push(this.mediaList.slice(i, i + columnSize))
            }
            return matrix
        },
        slow() {
            return this.$speed.isSlow
        },
        layoutColumns() {
            let columns = 1
            if (this.mediaList?.length >= 2) columns = this.columns
            return {
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
            }
        },
    },
    methods: {
        getComponentProps(media) {
            if (this.isVideo(media))
                return {
                    ...this.$attrs,
                    forcePlaceholder: this.$speed.isSlow !== false,
                    video: media,
                    muted: true,
                    autoplay: true,
                    loop: true,
                    playsinline: true,
                    preload: "none",
                }
            return {
                ...this.$attrs,
                image: media,
                alt: media.file_name ?? "Beschreibungsbild",
                size: "2",
                fit: "cover",
                width: 350,
                loading: "lazy",
            }
        },
        onVideoReady(index, jndex) {
            const videoRef =
                this.$refs[`job-gallery-media-${index}-${jndex}`][0]
            this.observeIntersection(
                videoRef?.$el,
                () => {
                    videoRef.playVideo()
                },
                () => {
                    videoRef.pauseVideo()
                },
                {
                    threshold: 0.4,
                }
            )
        },
    },
}
